import { store } from '@/decorators/store';
import { Layout } from '@/entities/Layout';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'LayoutStore' })
export class LayoutStore extends AbstractEntityStore<Layout> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'name';
  protected entityValueKey = 'name';
}
